module.exports = __webpack_public_path__ + "static/media/2025_BMS.eb806e42.png";